import { RISK_LEVELS, SERVICE_ACCOUNT_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { ServiceAccountInsight, ServiceAccountTab } from './ServiceAccountsTypes';

export const SERVICE_ACCOUNT_INSIGHTS: Record<string, ServiceAccountInsight> = {
    service_accounts: {
        title: 'Total Service Accounts',
        count: 0,
        disabled: true,
        info: 'The total number of service & hybrid accounts detected by Silverfort.'
    },
    protected: {
        title: 'Protected',
        filters: {
            is_protected: ['true']
        },
        count: 0,
        info: 'Count all Service and Hybrid Accounts with an active policy.'
    },
    no_owner: {
        title: 'Unassigned Owner',
        filters: {
            insights: ['no_owner'],
            owner: undefined,
            custom_owner: undefined
        },
        count: 0,
        info: 'Total number of service accounts without an assigned owner. Assign owners manually or automatically in Silverfort.'
    },
    brute_force: {
        title: 'Suspected Brute Force',
        filters: {
            insights: ['brute_force']
        },
        count: 0,
        info: 'The total number of service & hybrid accounts with over 150 failed authentications within 30 minutes (behavior typical of password brute force attempts).'
    },
    domain_admins: {
        title: 'Domain Admins',
        filters: {
            insights: ['domain_admins']
        },
        count: 0,
        info: 'The total number of service & hybrid accounts that are (direct or indirect) members of the Domain Admin AD group.'
    },
    high_privileged: {
        title: 'Highly Privileged',
        filters: {
            insights: ['high_privileged']
        },
        count: 0,
        info: 'The total number of service & hybrid accounts that are (direct or indirect) members of highly-privileged AD groups, including Domain Admins.'
    },
    interactive_login: {
        title: 'Interactive Login',
        filters: {
            insights: ['interactive_login']
        },
        count: 0,
        info: 'The total number of service accounts performing interactive, or remote interactive, logins using NTLM and Kerberos.'
    }
};

export const CLASSIFICATION_OPTIONS = Object.values(SERVICE_ACCOUNT_TYPES)
    .filter(({ type }) => type !== SERVICE_ACCOUNT_TYPES.REMOVED.type && type !== SERVICE_ACCOUNT_TYPES.ALL.type)
    .map((serviceAccountType) => {
        return { value: serviceAccountType.type, title: serviceAccountType.title };
    });

export const SERVICE_ACCOUNT_TABS: { [key: string]: ServiceAccountTab } = Object.values(SERVICE_ACCOUNT_TYPES).reduce(
    (acc, { title, type, description, showRemovedAccounts }, index) => {
        acc[type] = {
            name: title,
            value: index,
            type,
            description,
            showRemovedAccounts: showRemovedAccounts || false,
            amount: 0,
            selectedServiceAccounts: []
        };
        return acc;
    },
    {}
);

export const RISK_LEVELS_COUNTER = {
    [RISK_LEVELS.LOW.value]: 0,
    [RISK_LEVELS.MEDIUM.value]: 0,
    [RISK_LEVELS.HIGH.value]: 0,
    [RISK_LEVELS.CRITICAL.value]: 0
};
